/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successfully requested to follow someone
 */
export const sendFollowRequest201Schema = z.object({
  requestId: z.string(),
})

/**
 * @description Bad request
 */
export const sendFollowRequest400Schema = APIErrorSchema

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const sendFollowRequest401Schema = APIErrorSchema

/**
 * @description Request already exists or already following
 */
export const sendFollowRequest409Schema = APIErrorSchema

export const sendFollowRequestMutationRequestSchema = z.object({
  followeeId: z.string().describe("ID of the user to follow"),
})

export const sendFollowRequestMutationResponseSchema =
  sendFollowRequest201Schema
